import sideMenu from './sideMenu.json';

export default { sideMenu };
